import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';
import { PlusIcon, SecurityKeyIcon } from '@rsos/assets/icons';
import { Box, Button, Text, Modal } from '@rsos/components/capstone/base';
import { ModalBody } from '@rsos/components/capstone/base/Modal/ModalComponents';
import {
  fetchOrgToken,
  selectUserOrgByApp,
  swallowThunkRejection,
} from '@rsos/sinatra';
import { getProductName } from '@rsos/utils/metaTags';
import {
  createIntegrationTestAction,
  startIntegrationTestAction,
  startLEITestAction,
  startLISTestAction,
  startRADTestAction,
  startHERMESTestAction,
  startPsapDashTest,
  updateTestResults,
  updateResults,
  resetResults,
  adeleLogger,
} from '../../actions/adele';
import { fetchIntegrationAction } from '../../actions/integrations';
import { oAuthAction } from '../../actions/oAuth';
import { getAdeleProductToken } from '../../utils/getAdeleProductToken';
import { isAdminApproved } from '../../utils/isAdminApproved';
import { IconWrapper } from '../Main.styles';
import FormSite from './FormSite';
import IntegrationTests from './IntegrationTests/';
import {
  networkError,
  configError,
  authorizationError,
  hermesError,
  locationError,
} from './integrationErrors';

const productName = getProductName();

const ZD_TEST_ID_FIELD_ID = 360025035151;
const ZD_INTEGRATION_TEST_FORM_ID = 360000620992;
const ZD_KEY = '76ca57ca-fea0-45ed-93cb-c758ac251382';

//NOTE: this file needs to be re-visited, it does too much in 1 place
class IntegrationTestsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      testing: false,
      showTestId: false,
      renewalInProgress: false,
      isModalVisible: false,
    };
  }

  componentDidMount() {
    const {
      fetchIntegrationAction,
      token,
      user,
      productToken,
      productTokenExpiration,
      jurisdictions,
      fetchOrgToken,
      sinatra,
    } = this.props;

    const orgName = user.profile.organizations[0].name;
    const orgID = user.profile.organizations[0].id;
    if (!productToken) {
      // fetchOrgToken dispatches its own error action on failure, so redux state
      // is already updated; catch the rejection so this best-effort token fetch
      // cannot surface as an unhandled promise rejection.
      fetchOrgToken(orgID, productName).catch(swallowThunkRejection);
    }
    //call integrations Action
    fetchIntegrationAction(orgName, token);
    const { renewalInProgress } = this.state;
    let org = selectUserOrgByApp(sinatra, 'capstone');

    if (!productToken && isAdminApproved(jurisdictions) && org.id) {
      fetchOrgToken(org.id, productName).catch(swallowThunkRejection);
    }
    // Check if should renew token on page refresh
    const now = new Date().getTime();
    if (!renewalInProgress && productToken && now < productTokenExpiration) {
      this.renewToken();
    }
  }

  renewToken = () => {
    if (!this.state.renewalInProgress) {
      let org = selectUserOrgByApp(this.props.sinatra, 'capstone');
      this.setState({ renewalInProgress: true });
      setTimeout(() => {
        this.setState(
          {
            renewalInProgress: false,
          },
          () => {
            if (org) {
              this.props
                .fetchOrgToken(org.id, productName)
                .catch(swallowThunkRejection);
            }
          },
        );
      }, this.props.productTokenExpiration - new Date().getTime());
    }
  };

  toggleZenDesk = () => {
    const script = document.createElement('script');
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${ZD_KEY}`;

    script.id = 'ze-snippet';
    script.async = true;
    document.body.appendChild(script);

    let callback = () => {
      window.zESettings = {
        webWidget: {
          color: { theme: '#29ABE0' },
          contactForm: {
            ticketForms: [{ id: ZD_INTEGRATION_TEST_FORM_ID }],
            fields: [
              {
                id: ZD_TEST_ID_FIELD_ID,
                prefill: { '*': this.props.testData.data.test_id },
              },
            ],
          },
        },
      };

      window.zE('webWidget', 'prefill', {
        email: {
          value: this.props.user.profile.email,
          readOnly: true, // optional
        },
      });

      window.zE('webWidget', 'show');
      window.zE('webWidget', 'open');
    };

    script.onload = callback;
  };

  componentWillUnmount() {
    // The Inbound page shares this redux slice and stores an object in it, so
    // `integrations` is not always the array testFailCheck maps over. Throwing
    // here happens during React's unmount commit, which takes down the whole
    // admin route tree via the error boundary; render() guards the same way.
    if (Array.isArray(this.props.integrations)) {
      if (this.testFailCheck(this.props.integrations)) {
        window.zE('webWidget', 'hide');
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { testData, productToken, testResults, integrations } = this.props;
    if (testData !== prevProps.testData && testData && productToken) {
      this.startIntegrationTest(this.props.testData.data.test_id);
    }

    if (
      testResults &&
      integrations &&
      testResults !== prevProps.testResults &&
      testResults.length === integrations.length
    ) {
      this.setState(
        {
          testing: false,
          showTestId: true,
        },
        () => {
          this.logTestResults(testData, productToken);
        },
      );
    }

    const now = new Date().getTime();
    if (
      !prevState.renewalInProgress &&
      !this.state.renewalInProgress &&
      productToken &&
      now < this.props.productTokenExpiration
    ) {
      this.renewToken();
    }
  }

  toggleIsModalVisible = () => {
    this.setState({
      isModalVisible: !this.state.isModalVisible,
    });
  };

  testAllIntegrations = () => {
    this.setState(
      {
        testing: true,
      },
      () => {
        //create test
        this.createIntegrationTest(this.props.productToken);
      },
    );
  };

  createIntegrationTest = () => {
    const { createIntegrationTestAction, currentPSAP, sinatra } = this.props;
    const expandedPolygonInt = 0.0001;

    let latitude = currentPSAP.jurisdictions[0]
        ? currentPSAP.jurisdictions[0].exact_polygon
          ? currentPSAP.jurisdictions[0].exact_polygon.features[0].geometry
              .coordinates[0][0][0][1]
          : currentPSAP.jurisdictions[0].expanded_polygon.features[0].geometry
              .coordinates[0][0][0][1] + expandedPolygonInt
        : '',
      longitude = currentPSAP.jurisdictions[0]
        ? currentPSAP.jurisdictions[0].exact_polygon
          ? currentPSAP.jurisdictions[0].exact_polygon.features[0].geometry
              .coordinates[0][0][0][0]
          : currentPSAP.jurisdictions[0].expanded_polygon.features[0].geometry
              .coordinates[0][0][0][0] + expandedPolygonInt
        : '';

    let requestBody = {
      test_type: 'data',
      authority_name: currentPSAP.name,
      latitude,
      longitude,
    };

    const org = selectUserOrgByApp(sinatra, 'capstone');

    this.props
      .fetchOrgToken(org.id, productName)
      .then(response => {
        createIntegrationTestAction(requestBody, response.token);
      })
      .catch(swallowThunkRejection);
  };

  startIntegrationTest = testId => {
    const { startIntegrationTestAction, productToken, resetResults } =
      this.props;
    resetResults();
    startIntegrationTestAction(testId, productToken).then(() => {
      this.authenticateTest();
    });
  };

  authenticateTest = () => {
    const { oAuthAction, integrations } = this.props;

    let tests = new Promise(resolve => {
      setTimeout(() => {
        resolve(
          integrations.map(integration => {
            //loop throgh integrations api's
            //get creds and validate
            const apiData = integration.apisData.map(data => {
              return data;
            });

            let credentials = integration.credentials;
            // oauth for api token
            credentials.grant_type = 'client_credentials';
            let body = qs.stringify(credentials);

            oAuthAction(body).then(res => {
              //run test
              this.runTest(
                apiData,
                res.payload.data.access_token,
                credentials,
                integration.name,
              );
            });
            return integration;
          }),
        );
      }, 1000);
    });

    return tests;
  };

  runTest = (apiData, oAuthToken, credentials, name) => {
    const {
      testData,
      startLEITestAction,
      startLISTestAction,
      startRADTestAction,
      startPsapDashTest,
      startHERMESTestAction,
      currentPSAP,
    } = this.props;
    const testID = testData.data.test_id;
    const rave_id = currentPSAP.rave_id;

    let tests = new Promise(resolve => {
      setTimeout(() => {
        resolve(
          apiData.map(integration => {
            if (integration.name === 'LEI') {
              this.testIntegrationAPI(
                startLEITestAction,
                oAuthToken,
                null,
                name,
                rave_id,
              ).then(res => {
                integration.response = res.payload;
                const statusCode =
                  res.payload.status || res.payload.response.status;
                this.integrationTestCase(statusCode, integration, testID);
              });
            } else if (integration.name === 'LIS') {
              this.testIntegrationAPI(
                startLISTestAction,
                oAuthToken,
                credentials,
              ).then(res => {
                integration.response = res.payload;
                const statusCode = res.payload.status
                  ? res.payload.status
                  : res.payload.response
                    ? res.payload.response.status
                    : 503;
                this.integrationTestCase(statusCode, integration, testID);
              });
            } else if (integration.name === 'RAD') {
              this.testIntegrationAPI(
                startRADTestAction,
                oAuthToken,
                null,
                name,
                rave_id,
              ).then(res => {
                integration.response = res.payload;
                const statusCode =
                  res.payload.status || res.payload.response.status;
                this.integrationTestCase(statusCode, integration, testID);
              });
            } else if (integration.name === 'PSAP-Dashboard') {
              this.testIntegrationAPI(startPsapDashTest, oAuthToken).then(
                res => {
                  integration.response = res.payload;
                  if (res.type === 'PSAP_DASHBOARD_SUCCESS') {
                    this.handleIntegrationTestPass(integration);
                  } else if (res.type === 'PSAP_DASHBOARD_ERROR') {
                    const statusCode = res.payload.response.status;
                    this.handleIntegrationTestFail(
                      integration,
                      statusCode,
                      testID,
                    );
                  }
                },
              );
            } else if (integration.name === 'Hermes') {
              this.testIntegrationAPI(startHERMESTestAction, oAuthToken).then(
                res => {
                  integration.response = res.payload;
                  if (res.type === 'HERMES_TEST_SUCCESS') {
                    this.handleIntegrationTestPass(integration);
                  } else {
                    integration.status = 'fail';
                    integration.error = hermesError();
                    integration.statusCode = 503;
                  }
                },
              );
            }
            return integration;
          }),
        );
      }, 5000);
    });

    return Promise.all([tests]).then(values => {
      setTimeout(() => {
        let status;
        let productStatus = values[0].filter(item => {
          return item.status === 'fail';
        });

        if (productStatus.length >= 1) {
          status = 'failed';
        } else {
          status = 'passed';
        }

        let testResults = {
          name: name,
          resutls: values[0],
          status,
        };
        this.props.updateResults(testResults);
      }, 10000);
    });
  };

  integrationTestCase = (status, integration, testID) => {
    if (status === 200) {
      this.handleIntegrationTestPass(integration, status);
    } else if (integration.name === 'RAD' && status === 404) {
      this.handleIntegrationTestPass(integration, status);
    } else {
      this.handleIntegrationTestFail(integration, status, testID);
    }
  };

  testIntegrationAPI = (
    integrationTestAction,
    oAuthToken,
    credentials,
    name,
    rave_id,
  ) => {
    const { testData } = this.props;
    const phone_number = testData.data.phone_number;

    if (credentials) {
      return integrationTestAction(phone_number, credentials);
    }
    return integrationTestAction(phone_number, oAuthToken, name, rave_id);
  };

  handleIntegrationTestFail = (integration, statusCode) => {
    integration.status = 'fail';
    if (statusCode === 404 && integration.name === 'LEI') {
      integration.error = locationError();
      integration.statusCode = 404;
    } else if (statusCode === 401) {
      integration.error = authorizationError();
      integration.statusCode = 401;
    } else if (statusCode === 403) {
      integration.error = configError();
      integration.statusCode = 403;
    } else if (statusCode === 404) {
      integration.error = configError();
      integration.statusCode = 404;
    } else if (statusCode === 500) {
      integration.error = configError();
      integration.statusCode = 500;
    } else if (statusCode === 503) {
      integration.error = networkError();
      integration.statusCode = 503;
    } else if (statusCode === 502) {
      integration.error = networkError();
      integration.statusCode = 502;
    } else if (statusCode === 504) {
      integration.error = networkError();
      integration.statusCode = 504;
    } else {
      integration.error = configError();
    }
  };

  handleIntegrationTestPass = (integration, statusCode) => {
    integration.status = 'pass';
    integration.error = null;
    integration.statusCode = statusCode;
  };

  logTestResults = (testData, productToken) => {
    //adele logger action
    const { adeleLogger, integrations } = this.props;

    let testResuts = integrations.map(api => {
      return {
        results: api.apisData,
        name: api.name,
      };
    });

    // Support team requested to temporarily hide the Zendesk widget.
    // if (this.testFailCheck(integrations)) {
    //   this.toggleZenDesk();
    // }

    const testID = testData.data.test_id;
    adeleLogger(testID, productToken, testResuts);
  };

  testFailCheck = integrations => {
    let testResuts = integrations.map(api => {
      return {
        results: api.apisData,
        name: api.name,
      };
    });
    //check for failures
    let failcheck = testResuts.map(result => {
      return result.results.some(function (el) {
        return el.status === 'fail';
      });
    });

    return failcheck.includes(true);
  };

  render() {
    const { fetchingData, integrations } = this.props;
    const { isModalVisible, testing } = this.state;
    const { toggleIsModalVisible, testAllIntegrations } = this;
    const hasIntegrations =
      integrations && Array.isArray(integrations) && integrations.length > 0;
    return (
      <>
        <Box horizontal flow={7} m={'16px 0'}>
          <Button
            size="med"
            btnType="primary"
            onClick={testAllIntegrations}
            disabled={!hasIntegrations || testing || fetchingData}
            m={'0 9px 0 0'}
          >
            <IconWrapper px={1}>
              <SecurityKeyIcon height={13} width={13} />
            </IconWrapper>
            Test These Credentials
          </Button>
          <Button
            size="med"
            btnType="secondary"
            onClick={toggleIsModalVisible}
            m={0}
          >
            <IconWrapper px={1} color="secondaryLink">
              <PlusIcon height={13} width={13} />
            </IconWrapper>
            <Text color={'secondaryText'}>Request Credentials</Text>
          </Button>
        </Box>
        <Box my={20} flow={10}>
          {fetchingData ||
          !integrations ||
          !Array.isArray(integrations) ? null : (
            <IntegrationTests integrations={integrations} testing={testing} />
          )}
          <Modal
            isOpened={isModalVisible}
            onClose={toggleIsModalVisible}
            width={850}
            id="modal-form-site"
          >
            <ModalBody onClose={toggleIsModalVisible}>
              <FormSite />
            </ModalBody>
          </Modal>
        </Box>
      </>
    );
  }
}

const mapStateToProps = state => {
  const { productToken } = getAdeleProductToken(state.sinatra);
  const { productTokenExpiration } = getAdeleProductToken(state.sinatra);
  return {
    currentPSAP: state.psaps.currentPSAP,
    token: state.sinatra.auth.tokens.token,
    user: state.sinatra.user,
    integrations: state.integrations.data,
    fetchingData: state.integrations.fetchingData,
    testData: state.adele.adeleTestData,
    testResults: state.adele.testResults,
    sinatra: state.sinatra,
    productToken,
    productTokenExpiration,
  };
};

const mapDispatchToProps = {
  fetchIntegrationAction,
  createIntegrationTestAction,
  startIntegrationTestAction,
  startLEITestAction,
  updateTestResults,
  oAuthAction,
  startLISTestAction,
  startRADTestAction,
  startHERMESTestAction,
  startPsapDashTest,
  updateResults,
  resetResults,
  adeleLogger,
  fetchOrgToken,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IntegrationTestsContainer);
